"use strict";

var DEFAULT_MESSAGE = 'A network issue occurred. You might experience some shortcomings';
var CLIENT_FETCH_ERROR_UNKNOWN = 'Try again, an unfamiliar error interfered with your request';
var CLIENT_FETCH_ERROR_DEFAULT = 'Try again, a sudden network hiccup interrupted your request';
var CLIENT_FETCH_ERROR_NATIVE_MESSAGES = ['NetworkError when attempting to fetch resource',
// firefox
'Failed to fetch',
// chrome
'Network request failed',
// github/fetch polyfill
'Value is not a valid ByteString' // invalid headers
];
var CLIENT_NATIVE_ERROR_REGEX_LIST = CLIENT_FETCH_ERROR_NATIVE_MESSAGES.map(function (name) {
  return new RegExp(name, 'i');
});
function errorMessageFormatter(error) {
  var message;
  if (error instanceof TypeError) {
    message = CLIENT_FETCH_ERROR_UNKNOWN;
    CLIENT_NATIVE_ERROR_REGEX_LIST.forEach(function (regex) {
      if (regex.test(error.message)) {
        message = CLIENT_FETCH_ERROR_DEFAULT;
      }
    });
  }
  return message || DEFAULT_MESSAGE;
}
module.exports = errorMessageFormatter;
//# sourceMappingURL=errorMessageFormatter.js.map